import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { Store } from '@ngrx/store';
import {
  DsFormFieldModule,
  DsSelectModule,
  ISizeInput,
  SelectListOption,
} from '@bmw-ds/components';
import { switchCountry } from '../../state/current-user/current-user.actions';
import { selectUserState } from '../../state/current-user/current-user.selectors';
import { FormsModule } from '@angular/forms';
import { SelectListSortPipe } from '../pipes/select-list-sort.pipe';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tqc-switch-country',
  imports: [DsFormFieldModule, DsSelectModule, FormsModule, SelectListSortPipe],
  templateUrl: './switch-country.component.html',
  standalone: true,
  styleUrl: './switch-country.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchCountryComponent {
  private readonly store = inject(Store);
  public readonly translateService = inject(TranslateService);

  public readonly size = input<ISizeInput>('lg');

  private readonly userState = this.store.selectSignal(selectUserState);

  public readonly currentUserActiveCountry = computed(
    () => this.userState().user.activeCountry?.id?.toString() ?? ''
  );
  public readonly currentUserCountryOptions = computed<SelectListOption[]>(() =>
    (this.userState().user.availableCountries ?? []).map(
      (country): SelectListOption => ({
        id: country.id.toString(),
        label: country.code ?? country.tqcCountryCode,
      })
    )
  );

  public onCurrentUserCountryChange(selectedCountry: unknown): void {
    this.store.dispatch(
      switchCountry({
        countryId: Number(selectedCountry),
      })
    );
  }
}
